export default "__VITE_ASSET__B3X3iJqB__"